import { ControlIcons } from 'owa-control-icons';
import SmimeType from 'owa-smime-adapter/lib/store/schema/SmimeType';

const getIconForSmimeType = (smimeType: SmimeType): ControlIcons => {
    switch (smimeType) {
        case SmimeType.Unknown:
        case SmimeType.Encrypted:
        case SmimeType.SignedThenEncrypted:
        case SmimeType.EncryptedThenSigned:
        case SmimeType.TripleWrapped:
            return ControlIcons.Lock;
        case SmimeType.ClearSigned:
        case SmimeType.OpaqueSigned:
            return ControlIcons.Ribbon;
        case SmimeType.None:
        default:
            return null;
    }
};

export default getIconForSmimeType;
